import * as angular from 'angular';
import FdxTransformersFieldDependencyTreeModalController from './fdx-transformers-field-dependency-tree-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-transformers-field-dependency-tree-modal.styles.scss';

export const componentName = 'fdxTransformersFieldDependencyTreeModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-transformers-field-dependency-tree-modal.template.html'),
	controller: FdxTransformersFieldDependencyTreeModalController,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});
